import { createClient, SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '../types/supabase.ts';

// Environment configuration interface
interface SupabaseConfig {
  url: string;
  anonKey: string;
}

// Validate environment variables
const getSupabaseConfig = (): SupabaseConfig => {
  const url = import.meta.env.VITE_SUPABASE_URL as string;
  const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

  if (!url) {
    throw new Error('Missing VITE_SUPABASE_URL environment variable');
  }

  if (!anonKey) {
    throw new Error('Missing VITE_SUPABASE_ANON_KEY environment variable');
  }

  return { url, anonKey };
};

// Get configuration
const config = getSupabaseConfig();

// Create typed Supabase client with proper headers
export const supabase: SupabaseClient<Database> = createClient<Database>(
  config.url,
  config.anonKey,
  {
    global: {
      headers: {
        'Accept': 'application/json',
      },
    },
  }
);

// Export type for use in other files
export type TypedSupabaseClient = typeof supabase;
export type { Database } from '../types/supabase.ts';
